<template>
  <div>
    <Menu mode="horizontal" theme="light" :active-name="$route.name" @on-select="selectMenu">
      <MenuItem :name="item.name" v-for="item in menus" :key="item.name" v-if="!item.disabled">
        <Icon :type="item.icon" class="icon-iconfont" />
        {{ item.label }}
      </MenuItem>
    </Menu>
  </div>
</template>

<script>
import { checkPrivateCloudNodeHaveCloud } from '@/api/private-cloud/node'

export default {
  name: 'menu',
  data () {
    return {
      menus: [
        {name: 'home-report-cost', icon: 'iconfont icon-fixed_assets', label: '费用'},
        {name: 'home-report-domain', icon: 'iconfont icon-network2', label: '域名'},
        {name: 'home-report-server', icon: 'iconfont icon-server', label: '服务器'},
        {name: 'home-report-asset', icon: 'iconfont icon-asset-manage', label: '固定资产'},
        {name: 'home-report-code_release', icon: 'iconfont icon-webcodelanguageprogramwebdesigncompu', label: '代码发布统计'},
        {name: 'home-report-sql_exec', icon: 'iconfont icon-sql', label: 'SQL执行统计'},
        {name: 'home-report-data_migrate', icon: 'iconfont icon-aaaa', label: '数据迁移统计'}
        // {name: 'home-report-private_cloud', icon: 'iconfont icon-cloudlogo', label: '私有云'},
        // {name: 'home-report-jenkins', icon: 'iconfont icon-jenkins', label: 'Jenkins'}
      ],
      defaultShow: 0,
      privateCloudRouterDisabled: {name: 'home-report-private_cloud', icon: 'iconfont icon-cloudlogo', label: '私有云'}
    }
  },
  watch: {
    '$store.state.user.defaultTenant' () {
      this.checkPrivateCloud()
    }
  },
  created: function () {
    this.checkPrivateCloud()
  },
  methods: {
    selectMenu (name) {
      this.$router.push({name: name})
    },
    inDefault () {
      this.selectMenu(this.menus[this.defaultShow].name)
    },
    checkPrivateCloud () {
      let baseMenus = [
        {name: 'home-report-cost', icon: 'iconfont icon-fixed_assets', label: '费用'},
        {name: 'home-report-domain', icon: 'iconfont icon-network2', label: '域名'},
        {name: 'home-report-server', icon: 'iconfont icon-server', label: '服务器'},
        {name: 'home-report-asset', icon: 'iconfont icon-asset-manage', label: '固定资产'},
        {name: 'home-report-code_release', icon: 'iconfont icon-webcodelanguageprogramwebdesigncompu', label: '代码发布统计'},
        {name: 'home-report-sql_exec', icon: 'iconfont icon-sql', label: 'SQL执行统计'},
        {name: 'home-report-data_migrate', icon: 'iconfont icon-aaaa', label: '数据迁移统计'}
        // {name: 'home-report-private_cloud', icon: 'iconfont icon-cloudlogo', label: '私有云'},
        // {name: 'home-report-jenkins', icon: 'iconfont icon-jenkins', label: 'Jenkins'}
      ]
      checkPrivateCloudNodeHaveCloud().then(res => {
        if (res.data.result) {
          let menus = baseMenus
          menus.push(this.privateCloudRouterDisabled)
          this.menus = menus
        } else {
          this.menus = baseMenus
        }
      }).catch(res => {
        this.menus = baseMenus
        console.err(res)
      })
    }
  }
}
</script>

<style scoped>
  .icon-iconfont {
    font-family: iconfont;
  }
</style>
